import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate(next);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center px-6 py-20" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center">
          <div className="label-eyebrow">Member Access</div>
          <h1 className="mt-4 font-serif text-5xl text-bdu-cream tracking-tight">Welcome Back</h1>
          <p className="mt-3 text-bdu-cream/60">Sign in to your Black Dollars United account.</p>
        </div>

        <form onSubmit={onSubmit} className="mt-10 bdu-card p-8 space-y-5">
          <div>
            <div className="label-eyebrow mb-3">Email</div>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border border-bdu-gold/25 px-4 py-3 text-bdu-cream outline-none focus:border-bdu-gold"
              data-testid="login-email-input" />
          </div>
          <div>
            <div className="label-eyebrow mb-3">Password</div>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border border-bdu-gold/25 px-4 py-3 text-bdu-cream outline-none focus:border-bdu-gold"
              data-testid="login-password-input" />
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full justify-center" data-testid="login-submit-btn">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="mt-8 text-center text-sm text-bdu-cream/60">
          New to the movement?{" "}
          <Link to={`/register${next ? `?next=${next}` : ""}`} className="text-bdu-gold hover:underline" data-testid="login-to-register-link">Join the fund</Link>
        </p>
      </div>
    </div>
  );
}
